import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.user.initialUrl;
//VERIFY IF THE JWT IS SET
const getInitialUrl = createSelector(getData, url => url);
export default getInitialUrl;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getInitialUrl.js